import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useNavigationByRole } from 'src/hooks/useNavigationByRole'

import { CImage, CSidebar, CSidebarBrand, CSidebarNav, CSidebarToggler } from '@coreui/react-pro'

import { AppSidebarNav } from './AppSidebarNav'

import SimpleBar from 'simplebar-react'
import 'simplebar/dist/simplebar.min.css'
import CIcon from '@coreui/icons-react'

import './AppSidebar.css'
import { sygnet } from 'src/assets/brand/sygnet'
import { logoNegative } from 'src/assets/brand/logo-negative'

const AppSidebar = () => {
  const dispatch = useDispatch()
  const unfoldable = useSelector((state) => state.sidebarUnfoldable)
  const sidebarShow = useSelector((state) => state.sidebarShow)
  const logo = useSelector((state) => state.subdomainConfig.logo)
  const logoRounded = useSelector((state) => state.subdomainConfig.logoRounded)
  const selectedRole = useSelector((state) => state.selectedRole)
  const { menuItems } = useNavigationByRole(selectedRole)

  return (
    <CSidebar
      colorScheme="light"
      position="fixed"
      unfoldable={unfoldable}
      visible={sidebarShow}
      onVisibleChange={(visible) => {
        dispatch({ type: 'set', sidebarShow: visible })
      }}
    >
      <CSidebarBrand className="d-none d-md-flex" to="/">
        {logo ? (
          <CImage className="sidebar-brand-full" src={logo} height={35} />
        ) : (
          <CIcon className="sidebar-brand-full" icon={logoNegative} height={35} />
        )}
        {logoRounded ? (
          <CImage className="sidebar-brand-narrow" src={logoRounded} height={35} />
        ) : (
          <CIcon className="sidebar-brand-narrow" icon={sygnet} height={35} />
        )}
      </CSidebarBrand>
      <CSidebarNav>
        <SimpleBar style={{ height: '100%' }}>
          <AppSidebarNav items={menuItems} />
        </SimpleBar>
      </CSidebarNav>
      <CSidebarToggler
        className="d-none d-lg-flex"
        onClick={() => dispatch({ type: 'set', sidebarUnfoldable: !unfoldable })}
      />
    </CSidebar>
  )
}

export default React.memo(AppSidebar)
